import { Col, Row } from "antd";
import React, { useEffect } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getAllObjectives } from "../../../apis/actions/objectives.actions";
import Loader from "../../../biblio/Loader/Loader";

const ObjectivesPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { objectives, loading } = useSelector(
    (state: RootState) => state?.objectives.objectives
  );

  useEffect(() => {
    dispatch(getAllObjectives());
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }

  const hasObjectives =
    objectives && Array.isArray(objectives) && objectives.length > 0;
  const firstObjective = hasObjectives ? objectives[0] : null;

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="من نحن"
      subTitle="أهداف الجمعية"
      urlImage={banner}
      className="takaful--our-branches"
    >
      {" "}
      <Row dir="rtl" gutter={16} justify={"space-between"}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col
          xxl={10}
          xl={10}
          lg={10}
          md={24}
          sm={24}
          xs={24}
          className="takaful--story-text-content"
        >
          <p className="takaful--story-text">
            {firstObjective?.description || ""}
          </p>
        </Col>
        <Col
          xxl={11}
          xl={11}
          lg={11}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          {firstObjective?.objective_attachment_ids?.[0] && (
            <img
              className="takaful--our-story-img"
              src={firstObjective.objective_attachment_ids[0]}
              alt=""
            />
          )}
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>
    </MenuItemLayout>
  );
};

export default ObjectivesPage;
